import { keyframes } from 'styled-components';

export const stretchInDown = keyframes`
  from {
    opacity: 0;
    transform: scale3d(1, 0, 1);
    transform-origin: top center;
  }
  
  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
`;

